import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-133" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-134" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="7 dages tilfredshedsgaranti" data-id="element-135" data-mp="222wjc7wug0nm">
          <defs data-id="element-136" data-mp="19e7pmty4axlw">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-137" data-mp="19fsjehclycip" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-138" data-mp="14h8tk5uw8gl2" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-139" data-mp="1j650fzl7rnk3" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-140" data-mp="1ec98bdrmsuwu">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-141" data-mp="lp6bqr6imu98">
              TILFREDSHEDSGARANTI · KØB TRYGT ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-142" data-mp="oxfac9teapsk">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-143" data-mp="yp2vxu39tcm4">
            DAGE
          </text>
        </svg>

        <div data-id="element-144" data-mp="61yv81b7nkg5">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-145" data-mp="62i3eqb26ugz">
            7 dages tilfredshedsgaranti
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-146" data-mp="f12h1d1ridyc">
            Hent materialet og se, hvordan det fungerer i dine matematiktimer. Er du mod forventning
            utilfreds med pakken, kan du skrive til os og få pengene tilbage inden for 7 dage
            efter købet i henhold til garantibetingelserne.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-147" data-mp="1vhok8bggtwy0">
            Garantien begrænser på ingen måde dine rettigheder efter forbrugerlovgivningen.
          </p>
        </div>
      </div>
    </section>;
}